module.exports = __webpack_public_path__ + "img/Product2.c4fda10b.svg";